import 'array-flat-polyfill';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import CONFIG_ENV from './config/config-env';
import './index.css';
import store from './store/store';
import initSentryMonitoring from './utils/sentry';

const App = lazy(() => import('./app/App'));
const PreviewEditor = lazy(() => import('./lib/PreviewEditor'));

const RedirectedApp = () => {
  return (
    <Router>
      <Suspense fallback={null}>
        <Switch>
          <Route path='/storyblok-preview/*'>
            <Provider store={store}>
              <PreviewEditor />
            </Provider>
          </Route>
          <Route path='*'>
            <App />
          </Route>
        </Switch>
      </Suspense>
    </Router>
  );
};

(async () => {
  const {
    sentry: { active, dataSourceName, environment }
  } = CONFIG_ENV;
  if (active) initSentryMonitoring(dataSourceName, environment as any);

  const LDProvider = await asyncWithLDProvider({
    ...CONFIG_ENV.launchDarkly
  });

  ReactDOM.render(
    <LDProvider>
      <RedirectedApp />
    </LDProvider>,
    document.getElementById('root')
  );
})();
